import { useSelector } from 'react-redux';
import { useRequest } from 'redux-query-react';
import {
    customerAuthStatusRequest,
    ICustomerAuthStatus,
    ICustomerAuthStatusResponse,
} from 'data/requests/customer/customerAuthStatusRequest';

export interface IAuth {
    isLoggedIn: boolean;
    customer?: ICustomerAuthStatus;
    isFinished: boolean;
}

const mapStateToProps = (state) => state.entities.customerAuthStatusRequest as ICustomerAuthStatusResponse;

// Rendered by Upitech\FastFront\Block\Assets; the page cache varies by login state, so guests can
// be answered without hitting the uncacheable endpoint at all.
export const getIsLoggedIn = (): boolean => window.IS_LOGGED_IN === true;

export const useAuth = (): IAuth => {
    const isLoggedIn = getIsLoggedIn();
    const [{ isFinished }] = useRequest(isLoggedIn ? customerAuthStatusRequest() : null);
    const authStatus = useSelector(mapStateToProps);

    return {
        isLoggedIn,
        customer: authStatus?.customer,
        isFinished: isLoggedIn ? isFinished : true,
    };
};
